<div class="row search-bar" style="justify-content: space-between">

  <!-- Search input -->
  <div [class]="showFilter ? 'col-lg-4 col-md-5 col-sm-5' : 'col-lg-4 col-md-5 col-sm-5'">
    <div class="form-group has-feedback input-group">
      <input (keyup.enter)="search()" [(ngModel)]="searchText" type="text"
             class="form-control has-feedback has-clear" id="search"
             style="font-family: Helvetica, FontAwesome" placeholder="&#xF002; Search...">
      <i *ngIf="searchText"
         (click)="clearSearch()"
         class="fa fa-times form-control-feedback"
         style="padding-top:10px; z-index:10; pointer-events: auto; cursor:pointer; position: absolute; right: 67px;"></i>
      <span class="input-group-btn">
        <button type="button" class="btn btn-primary" (click)="search()">
          <i class="fa fa-search"></i>
        </button>
      </span>
      <app-help-docs-links style="padding: 5px;" recordType="search" color="#000"></app-help-docs-links>
    </div>
  </div>

  <!-- Active filter chips -->
  <div *ngIf="showFilter && activeFilters.length > 0" class="col-lg-4 col-md-4 col-sm-2 activeFilters">
    <span *ngFor="let activeFilter of activeFilters"
          class="btn btn-default"
          style="padding:1px 5px; margin: 5px;"
          (click)="clearActiveFilter(activeFilter.key)"
          title="Clear this filter">
      <i class="fa fa-times"></i> {{ activeFilter.display }}
    </span>
  </div>

  <!-- Filter dropdown -->
  <div *ngIf="showFilter" class="col-lg-3 col-md-5 col-sm-6 pull-right search-filter"
       ngbDropdown placement="bottom-end" #filterMenu="ngbDropdown">
    <div class="dropdown" id="filterMenu">
      <div ngbDropdownToggle>
        <span><i class="fa fa-long-arrow-down"></i> Filter</span>
        <p style="color:#b8bcc0; white-space: nowrap;">Use filters to narrow your search</p>
      </div>
      <div ngbDropdownMenu style="width: 100%;">
        <ul id="filterMenuItems">

          <ng-container *ngFor="let field of filterFields; let i = index">
            <li *ngIf="metaLoaded && fieldMeta[field]">
              <div class="form-group" style="padding-right:10px; width: 100%">
                <app-dynamic-input [meta]="filterMeta" [item]="filterValues" [key]="field"
                                   [itemIndex]="i" [usePlaceHolderLabel]="true"
                                   (itemChange)="filterValues = $event">
                </app-dynamic-input>
              </div>
            </li>
          </ng-container>

          <li style="display: flex; justify-content: space-between;">
            <button type="button" class="btn btn-primary" (click)="applyFilter()">Apply</button>
            <button type="button" class="btn btn-secondary" (click)="clearFilters()">Clear Filter</button>
          </li>
        </ul>
      </div>
    </div>
  </div>

</div>

